import { LanguagesEnum } from '@/api/enums/languages.enum';
import {
  AUTO_PHISHING_BOOK_DEMO_DK,
  AUTO_PHISHING_BOOK_DEMO_EN,
} from '@/common/constants/external-urls';
import { LanguageContext } from '@/common/context/LanguageContext';
import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledContainer = styled(FlexContainer)`
  width: 100%;
  background: linear-gradient(90deg, var(--teal-medium), var(--teal-dark));
  border-radius: var(--medium-border-radius);
  padding: var(--big-padding);
  color: var(--white-main);
  overflow: hidden;
  margin-top: var(--default-padding);
`;

const FeatureBadge = styled.div`
  background-color: var(--teal-light);
  color: var(--teal-dark);
  border-radius: var(--default-border-radius);
  padding: var(--xxxsmall-padding) var(--small-padding);
  font-size: var(--xsmall-font-size);
  line-height: var(--xsmall-line-height);
  margin-bottom: var(--small-padding);
  display: inline-block;
  font-weight: 500;

  span {
    font-weight: 700;
  }
`;

const MainHeading = styled.h2`
  font-size: var(--heading-medium-font-size);
  line-height: var(--heading-medium-line-height);
  font-weight: 600;
  margin: 0;
  color: var(--white-main);
`;

const SubText = styled.p`
  font-size: var(--xsmall-font-size);
  line-height: var(--xsmall-line-height);
  color: var(--white-main);
  margin: var(--small-padding) 0 0 0;
`;

const ContentWrapper = styled.div`
  flex: 1;
`;

const ButtonWrapper = styled(FlexContainer)`
  flex: 1;
  align-items: flex-end;
  justify-content: flex-start;
  flex-direction: column;
`;

export const AutoPhishingSection = () => {
  const { t } = useTranslation();
  const { language } = useContext(LanguageContext);

  return (
    <StyledContainer
      id="auto-phishing-banner"
      direction="row"
      align="center"
      justify="space-between"
    >
      <ContentWrapper>
        <FeatureBadge>
          <span>{t('autophishing.feature') + ' - '}</span>
          {t('autophishing.badge')}
        </FeatureBadge>
        <MainHeading>{t('autophishing.heading')}</MainHeading>
      </ContentWrapper>

      <ButtonWrapper>
        <a
          id="auto-phishing-book-meeting"
          href={
            language === LanguagesEnum.DK
              ? AUTO_PHISHING_BOOK_DEMO_DK
              : AUTO_PHISHING_BOOK_DEMO_EN
          }
          target="_blank"
          rel="noopener noreferrer"
        >
          <AppButton label={t('autophishing.cta')} severity="success" />
        </a>
        <SubText>{t('autophishing.disclaimer')}</SubText>
      </ButtonWrapper>
    </StyledContainer>
  );
};
